import ApiService from "../common/apiService";
import { formatDate } from "../common/formatting";
import { CAC_ACKNOWLEDGE_TA_REPORT } from "./actions.type";

const cacAcknowledgeTAReport = {
  state: {
    cacAcknowledgeTaReportUsers: [],
    forMonths: null,
    selectedReportOption: 'CAC_ACKNOWLEDGED'
  },
  mutations:{
    cacAcknowledgeTaReportUsers(state, data){
      const format = 'DD MMM YYYY';
      for(const e of data) {
        e.name = {
          value: e.first_name + ' ' + e.last_name,
          link: '/admin/user/'+e.id
        };
        e.emailObj = {
          value: e.email,
          link: 'mailto:'+e.email
        };
        e.last_used = {
          value: (e.user_info && e.user_info.last_used)?formatDate(e.user_info.last_used, format):''
        };
        e.reviewed_at = {
          value: (e.user_info && e.user_info.reviewed_at)?formatDate(e.user_info.reviewed_at, format):''
        };
        e.cacUpdated_at = {
          value: (e.user_info && e.user_info.cacUpdated_at)?formatDate(e.user_info.cacUpdated_at, format):''
        };
      }
      state.cacAcknowledgeTaReportUsers = data;
    },
    forMonths(state, data) {
      state.forMonths = data;
    },
    selectedReportOption(state, data) {
      state.selectedReportOption = data;
    }
  },
  getters: {

  },
  actions: {
    [CAC_ACKNOWLEDGE_TA_REPORT](context,payload){
      this.commit('forMonths', payload.forMonths);
      this.commit('selectedReportOption', payload.selectedReportOption);

      return new Promise((resolve,reject)=>{
           ApiService.get('/admin/ta/cacacknowledge/'+payload.forMonths+'/'+payload.selectedReportOption)
             .then(({data}) => {
              this.commit('cacAcknowledgeTaReportUsers', data);
               resolve(data)
             })
             .catch(({response})=>{
               reject(response);
             })
        }
      );
    }
  },
};

export default cacAcknowledgeTAReport;
